// extracted by mini-css-extract-plugin
export default {"variant":"Variant_variant__6897Q","varNumber":"Variant_varNumber__ki9uw","varTitle":"Variant_varTitle__TbbmK"};